import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { FADE_UP_MOTION } from "@/lib/motion-presets";

export default function BookingSuccess({ t, bookingId, onReset }) {
  return (
    <motion.div
      {...FADE_UP_MOTION}
      className="card-surface p-10 sm:p-14 text-center"
      data-testid="booking-success-card"
    >
      <div className="mx-auto w-16 h-16 rounded-full bg-[#1995AD]/15 flex items-center justify-center mb-6">
        <Check className="w-8 h-8 text-[#0D5C75]" strokeWidth={2.2} />
      </div>
      <h3 className="font-heading text-3xl sm:text-4xl mb-3">
        {t.booking.success.title}
      </h3>
      <p className="max-w-md mx-auto text-[var(--body)] text-lg">
        {t.booking.success.body}
      </p>
      <div className="mt-8 inline-flex flex-col items-center gap-1 px-6 py-4 rounded-2xl bg-[var(--bg)] border border-[var(--border)]">
        <span className="label-eyebrow">{t.booking.success.ref}</span>
        <code
          className="text-[var(--heading)] font-bold tracking-wider"
          data-testid="booking-success-id"
        >
          {bookingId.slice(0, 8).toUpperCase()}
        </code>
      </div>
      <div className="mt-8">
        <button onClick={onReset} className="btn-secondary" data-testid="booking-new-btn">
          <Sparkles className="w-4 h-4" />
          {t.booking.success.cta}
        </button>
      </div>
    </motion.div>
  );
}
